<script setup>

</script>

<template>
    <h3 class="text-2xl font-medium">
        <slot></slot>
    </h3>
</template>
